import { render, staticRenderFns } from "./MypageTicketTodaySafeModalSection.vue?vue&type=template&id=3c1b8404&scoped=true"
import script from "./MypageTicketTodaySafeModalSection.vue?vue&type=script&lang=ts"
export * from "./MypageTicketTodaySafeModalSection.vue?vue&type=script&lang=ts"
import style0 from "./MypageTicketTodaySafeModalSection.vue?vue&type=style&index=0&id=3c1b8404&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1b8404",
  null
  
)

export default component.exports